import { render, staticRenderFns } from "./product_unique_code_receive_check.vue?vue&type=template&id=0433bf3a&scoped=true"
import script from "./product_unique_code_receive_check.vue?vue&type=script&lang=js"
export * from "./product_unique_code_receive_check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0433bf3a",
  null
  
)

export default component.exports